export enum PowerFlowGraphMode {
  OnlyGeneratedPower = 0,
  WithImportExport = 1,
  WithBattery = 2
}

export const pathIcons = {
  'battery': 'cmp-assets/battery.svg',
  'grid': 'cmp-assets/grid.svg',
  'home': 'cmp-assets/home.svg',
  'solar': 'cmp-assets/solar.svg',
}
